// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__ryKcV","label":"styles_label__80qoI","labelContent":"styles_labelContent__zlLdZ","labelText":"styles_labelText__k203f"};